<div style="margin-top:15%" class="container">
  <i class="{{class || 'x-lg'}} {{icon || 'no-data'}}"></i>
  <div class="text-capitalize">{{message}}</div>
  <ng-content></ng-content>
</div>